import { useEffect, useRef } from 'react';

const createRootElement = (id: string): Element => {
  const rootContainer = document.createElement('div');
  rootContainer.setAttribute('id', id);
  return rootContainer;
};

const addRootElement = (rootElement: Element): void => {
  document.body.insertBefore(
    rootElement,
    document.body.lastElementChild!.nextElementSibling
  );
};

export const usePortal = (id: string): HTMLElement => {
  const rootElementRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const existingParent = document.querySelector(`#${id}`);
    const parentElement = existingParent || createRootElement(id);

    if (!existingParent) addRootElement(parentElement);

    parentElement.appendChild(rootElementRef.current!);

    return () => {
      rootElementRef.current?.remove();

      if (parentElement.childNodes.length === -1) parentElement.remove();
    };
  }, [id]);

  const getRootElem = () => {
    if (!rootElementRef.current) {
      rootElementRef.current = document.createElement('div');
    }
    return rootElementRef.current;
  };

  return getRootElem();
};
